<script setup lang="ts">
import CESGFooter from '@/components/common/CESGFooter.vue';
import CESGHeader from '@/components/common/CESGHeader.vue';
import CESGNotifications from '@/components/common/CESGNotifications.vue';
import OverlaySpinner from '@/components/common/OverlaySpinner.vue';
import { appService } from '@/services/app/app-service';
import { computed, onMounted, onUnmounted, ref } from 'vue';

const rootAppKey = computed(() => appService.rootAppKey.value);
const showFooter = ref(false);

const updateFooterVisibility = () => {
  const hasScrolled = window.scrollY > 5;
  const canScroll = document.documentElement.scrollHeight > window.innerHeight;
  showFooter.value = hasScrolled || !canScroll;
};

onMounted(() => {
  window.addEventListener('scroll', updateFooterVisibility);
  updateFooterVisibility();
});

onUnmounted(() => {
  window.removeEventListener('scroll', updateFooterVisibility);
});
</script>

<template>
  <div class="cesg-container">
    <CESGHeader></CESGHeader>


    <main class="container is-fluid" :key="rootAppKey">
      <router-view v-if="$route.meta.isAdmin" />
      <router-view v-else />
    </main>

    <transition name="slide-up">
      <CESGFooter v-if="showFooter"></CESGFooter>
    </transition>

    <CESGNotifications></CESGNotifications>
    <OverlaySpinner></OverlaySpinner>
  </div>
</template>

<style scoped lang="scss">
.cesg-container {
  display: flex;
  flex-direction: column;

  .container {
    min-height: calc(100vh - 5px);
  }

  main {
    flex: 1;
  }
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition:
    transform 0.5s,
    opacity 0.5s;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.slide-up-leave-from,
.slide-up-enter-to {
  transform: translateY(0);
  opacity: 1;
}
</style>
